import React from 'react';
import {StreamBankLink} from "../../Common/StreamBankLink";

export const ContactNameTableColumn = (props) => {
    const { rowData, Value } = props;
    return (
        <StreamBankLink
            className="sb-actionable-link"
            Tool={"contacts/" + rowData.stakeholderId}
        >
            {Value}
        </StreamBankLink>
    );
};
